module.exports = __webpack_public_path__ + "img/webappBg.26139abd.png";